import { gql } from 'graphql-request';
import { DatoAssetQuery, Query } from './datoCMS';
import { z } from 'zod';

export const LinkQuery = new Query(
	gql`
		title
		page {
            ... on BlogRecord {
              slug
              _modelApiKey
            }
            ... on CaseRecord {
              slug
              _modelApiKey
            }
            ... on ContentPageRecord {
              slug
              _modelApiKey
            }
		}
		url
		email
		document{
			${DatoAssetQuery}
		}
	`,
	z.object({
		title: z.string(),
		slug: z.string().nullish(),
		page: z
			.object({
				_modelApiKey: z.string(),
				slug: z.string()
			})
			.nullish(),
		url: z.string().nullish(),
		email: z.string().nullish(),
		document: DatoAssetQuery.validation.nullish()
	}),
	(data) => {
		let slug = '';

		if (data.page) {
			if (data.page._modelApiKey === 'blog') {
				slug = `/nyheder/${data.page.slug}`;
			} else if (data.page._modelApiKey === 'case') {
				slug = `/cases/${data.page.slug}`;
			} else if (data.page._modelApiKey === 'content_page') {
				slug = `/${data.page.slug}`;
			}
		}

		return {
			...data,
			slug
		};
	}
);

export type LinkType = z.infer<typeof LinkQuery.validation>;
